// Rankings do servidor (Salão da Fama): escolhe a categoria e a vocation; mostra o top 100 com pódio.
import { useEffect, useState } from 'preact/hooks';
import { HS_CATEGORIES, type HsCategory, type HsRow } from '../../../../shared/src/game/highscores';
import { vocationTitle } from '../../../../shared/src/game/vocations';

const VOCS: Array<[string, string]> = [['', 'Todas'], ['knight', 'Knight'], ['paladin', 'Paladin'], ['sorcerer', 'Sorcerer'], ['druid', 'Druid'], ['monk', 'Monk']];
const VOC_ICON: Record<string, string> = { knight: '🛡️', paladin: '🏹', sorcerer: '🔥', druid: '🌿', monk: '👊' };
const HELP_KEY = 'nx-help-highscores';
const seenHelp = () => { try { return localStorage.getItem(HELP_KEY) === '1'; } catch { return true; } };

export function Highscores(props: { me?: string }) {
  const [cat, setCat] = useState<HsCategory>('experience');
  const [voc, setVoc] = useState('');
  const [rows, setRows] = useState<HsRow[] | null>(null);
  const [err, setErr] = useState('');
  const [help, setHelp] = useState(() => !seenHelp());
  useEffect(() => {
    let ok = true; setRows(null); setErr('');
    fetch(`/api/highscores?cat=${cat}&voc=${voc}`, { cache: 'no-cache' }).then((r) => r.json()).then((d) => { if (ok) Array.isArray(d) ? setRows(d) : setErr(d.error ?? 'Erro.'); })
      .catch(() => ok && setErr('Não foi possível carregar o ranking.'));
    return () => { ok = false; };
  }, [cat, voc]);
  const toggleHelp = () => { setHelp(!help); try { localStorage.setItem(HELP_KEY, '1'); } catch { /* sem storage */ } };
  const fmt = (v: number) => v.toLocaleString('pt-BR');
  const label = cat === 'week' ? 'XP da semana' : cat === 'experience' ? 'Experiência' : cat === 'gold' ? 'Gold' : cat === 'outfits' || cat === 'mounts' ? 'Pontos' : 'Nível';
  const catName = HS_CATEGORIES.find(([id]) => id === cat)?.[1] ?? '';
  const mine = rows?.find((r) => r.name === props.me);
  const podium = rows ? [rows[1], rows[0], rows[2]].filter((r): r is HsRow => !!r) : [];
  const vocName = (r: HsRow) => vocationTitle(r.vocation as any, r.promotion);

  return (
    <div class="hsx">
      {/* cabeçalho: o salão da fama */}
      <div class="hsx-head">
        <div class="hsx-trophy">🏆</div>
        <div class="hsx-head-txt">
          <div class="hsx-title">Salão da Fama <button class="hsx-help" onClick={toggleHelp} title="Como funciona">?</button></div>
          <div class="hsx-sub">Os nomes que Noxara não esquece. O seu pode ser o próximo.</div>
          <div class="hsx-tags">
            <span>{catName}</span>
            <span>{cat === 'week' ? 'Atualiza a cada 30 minutos' : 'Atualiza a cada minuto'}</span>
            <span>Top 100</span>
          </div>
        </div>
        <div class={'hsx-me' + (mine ? ' in' : '')} title={mine ? 'Sua posição neste ranking' : 'Você não está no top 100 deste ranking'}>
          <small>Sua posição</small>
          <b>{rows ? (mine ? `#${mine.rank}` : '—') : '…'}</b>
          <span>{rows ? (mine ? fmt(mine.value) : 'fora do top 100') : ''}</span>
        </div>
      </div>

      {help && (
        <div class="hsx-steps">
          <div><i>📜</i><b>1. Escolha o ranking</b><small>Experiência, skills, magic level, gold, outfits, montarias ou a XP da semana.</small></div>
          <div><i>⚔️</i><b>2. Filtre a vocation</b><small>Veja quem lidera entre os da sua classe, ou todas juntas.</small></div>
          <div><i>⭐</i><b>3. Ache seu nome</b><small>Sua linha fica destacada em dourado e sua posição aparece no topo.</small></div>
          <div><i>📅</i><b>4. Semanal</b><small>A XP da semana conta desde segunda-feira (Brasília). Os prêmios da semana serão anunciados.</small></div>
        </div>
      )}

      {/* filtros */}
      <div class="hsx-filters">
        <select value={cat} onChange={(e) => setCat((e.target as HTMLSelectElement).value as HsCategory)}>
          {HS_CATEGORIES.map(([id, l]) => <option key={id} value={id}>{l}</option>)}
        </select>
        <div class="hsx-vocs">
          {VOCS.map(([id, l]) => (
            <button key={id} class={'hsx-voc' + (voc === id ? ' on' : '')} onClick={() => setVoc(id)}>{id ? VOC_ICON[id] + ' ' : ''}{l}</button>
          ))}
        </div>
      </div>
      {cat === 'week' && <div class="hsx-note">XP ganha desde segunda-feira (Brasília). Atualiza a cada 30 minutos; os prêmios da semana serão anunciados.</div>}

      {err && <p class="error small">{err}</p>}
      {!rows && !err && <p class="muted small hsx-loading">Abrindo os pergaminhos...</p>}

      {/* pódio */}
      {!!podium.length && (
        <div class="hsx-podium">
          {podium.map((r) => (
            <div key={r.rank} class={'hsx-step p' + r.rank + (r.name === props.me ? ' me' : '')}>
              <div class="hsx-medal">{r.rank === 1 ? '👑' : r.rank === 2 ? '🥈' : '🥉'}</div>
              <b class="hsx-pname" title={r.name}>{r.name}</b>
              <small>{VOC_ICON[r.vocation] ?? ''} {vocName(r)} · lv {r.level}{r.resets ? ` · ${r.resets}R` : ''}</small>
              <div class="hsx-pval">{fmt(r.value)}<em>{label}</em></div>
              <div class="hsx-block">{r.rank}</div>
            </div>
          ))}
        </div>
      )}

      {/* restante da lista */}
      {rows && (
        <div class="hsx-table">
          <div class="hsx-row hsx-th"><span>#</span><span>Nome</span><span>Vocation</span><span>Level</span><span>{label}</span></div>
          {rows.filter((r) => r.rank > 3).map((r) => (
            <div key={r.rank} class={'hsx-row' + (r.name === props.me ? ' me' : '')}>
              <span class="hsx-rank">{r.rank}</span>
              <span class="hsx-name">{r.name}{r.name === props.me && <em> (você)</em>}</span>
              <span class="hsx-vocn">{VOC_ICON[r.vocation] ?? ''} {vocName(r)}</span>
              <span>{r.level}{r.resets ? <small class="muted"> · {r.resets} reset{r.resets > 1 ? 's' : ''}</small> : null}</span>
              <span class="hsx-val">{fmt(r.value)}</span>
            </div>
          ))}
          {!!rows.length && rows.length <= 3 && <p class="muted small hsx-empty">Só o pódio por enquanto. Sobra lugar para você.</p>}
          {!rows.length && <p class="muted small hsx-empty">Ninguém ainda. O primeiro lugar está vago!</p>}
        </div>
      )}
    </div>
  );
}
